let header = require('../../../actions/layout/header');
let footer = require('../../../actions/layout/footer');
let page = require('../../../actions/page');
let utils = require('../../../actions/utils');

module.exports = {
    /**
     * Установка основных полей для шапки и подвала
     * @type {Array}
     */
    setMainLayoutBlocks: [
        page.setCurrentPage,
        header.setHeaderMenu,
        utils.setPopupVisibility('settings', ['header', 'ui', 'settings', 'isOpen']),
        footer.setCopyrightYear
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/layout/index.js